export const splitByChunks = (array, limit) => {
  const chunks = [];

  for (let i = 0; i < array.length; i+=limit) {
    chunks.push(array.slice(i, i+limit))
  }

  return chunks
};
